import React from 'react'
import clsx from 'clsx'
import { getRawMessage } from '../../../locale'

const generalFormFieldClassesThatAllFieldsNeed = {
  'dashboard-formz-form-row': true,
}

const FieldRowWrapper = ({ className, touched, error, children }) => {
  const showErrors = () => {
    // field errors should be array or string. object is not a valid format
    if (Array.isArray(error)) return error.map((err) => `${err}\n`)
    if (typeof error === 'string') return error
    return getRawMessage('general.field.error.message')
  }

  return (
    <div
      className={clsx({
        ...generalFormFieldClassesThatAllFieldsNeed,
        ...className,
        // override the 'formz-has-error' to be applied only when the field is touched before
        'formz-has-error': className['formz-has-error'] && touched, // prevRule + touched
      })}
    >
      <div className="formz-form-element">{children}</div>
      <div className="formz-form-error">{error && showErrors()}</div>
    </div>
  )
}

export default FieldRowWrapper
